import {combineReducers} from 'redux';

import adminReducer from './admin/reducer';
import {backendApi} from './app/api/backendApi';
import backend from './app/backendSlice';
import appReducers from './app/reducers';
import assetsReducers from './assets/reducers';
import authReducers from './auth/reducers';

const reduxReducers = combineReducers({
  app: appReducers,
  auth: authReducers,
  assets: assetsReducers,
  admin: adminReducer,
  backend,
  [backendApi.reducerPath]: backendApi.reducer,
});

export type RootState = ReturnType<typeof reduxReducers>;
export default reduxReducers;
